module.exports = __webpack_public_path__ + "static/media/locked_users.fc4c61aa.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/new_menu_icons/locked_users.svg
// module id = 2707
// module chunks = 0